import {DocumentData, QueryDocumentSnapshot, SnapshotOptions} from "firebase/firestore"
import Song from "./Song"

export default class Playlist {
    static converter = {
        toFirestore  : (playlist: Playlist): DocumentData => {
            return {
                name : playlist.name,
                songs: playlist.songKeys
            }
        },
        fromFirestore: (snapshot: QueryDocumentSnapshot<DocumentData>, options?: SnapshotOptions): Playlist => {
            return new Playlist(snapshot.id, snapshot.data(options))
        }
    }
    key?: string
    name: string = ''
    songKeys: string[] = []

    public constructor(key?: string, data?: DocumentData) {
        if (key && data) {
            this.key = key
            this.name = data.name
            this.songKeys = data.songs || []
        }
    }

    public hasSong(song: Song): boolean {
        return this.songKeys.includes(song.key || '')
    }
}
